import React from "react";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";

export function Row(props) {
  const { row, setShowModalDeleteMember, setSelectedMember } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.firstName ?? ""}
        </TableCell>
        <TableCell align="center">{row?.nickName ?? ""}</TableCell>
        <TableCell align="center">{row?.email}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {/* <Typography variant="h6" gutterBottom component="div">
                  Acciones
                </Typography> */}

              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  onClick={() => {
                    setSelectedMember({
                      _id: row?.userId,
                      firstName: row?.firstName,
                    });

                    setShowModalDeleteMember(true);
                  }}
                  startIcon={<PersonRemoveIcon />}
                >
                  Eliminar corredor
                </Button>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
